<template>
	<svg class="ls-icon ls-icon-email" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
			<rect width="20" height="16" x="2" y="4" rx="2" />
			<path d="m22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
		</g>
	</svg>
</template>
